/**
 * 권한 트리 구성 — 도메인 › 탭 › 세부 권한.
 *
 * 왜 별도 파일인가
 *   권한을 계층으로 보여주는 화면이 둘이다 — 편집용 체크박스 트리(PermissionTree)와
 *   읽기 전용 유효 권한 트리(EffectivePermissionTree). 둘이 같은 계층을 각자 만들면
 *   한쪽만 고쳐져서 "편집 화면에선 재무 › 자금일보 아래인데 유효 권한에선 딴 데 있는" 식으로
 *   어긋난다. 묶는 규칙은 여기 하나뿐이다.
 *
 *   도메인·탭 이름의 유일한 출처는 백엔드 PermissionCode 의 domain·tab 필드다.
 *   프론트에서 분류표를 다시 만들지 않는다(만들면 권한 코드가 추가될 때마다 두 군데를 고쳐야 한다).
 *
 * 파일명 주의
 *   'permissionTree.js' 로 두면 안 된다 — macOS/Windows 는 파일명 대소문자를 구분하지 않아서
 *   같은 폴더의 PermissionTree.jsx 와 같은 모듈로 해석된다(default export 를 못 찾고 빌드가 깨진다).
 */

export const LEGACY_DOMAIN = "레거시";

/**
 * perms → [{ domain, tabs: [{ tab, perms: [...] }] }]
 *
 * <p>배열 순서는 백엔드가 준 순서를 그대로 유지한다(PermissionAdminService 가 PermissionCode
 * 선언 순으로 정렬해서 내려준다). 여기서 다시 정렬하면 환경마다 순서가 달라진다.
 *
 * @param {Array<{code, nameKr, description, domain, tab}>} perms
 * @param {{ skipLegacy?: boolean, filter?: (p) => boolean }} [opts]
 *        skipLegacy — 레거시 도메인 제외(편집 트리는 제외, 유효 권한 보기는 포함한다.
 *                     이미 부여된 권한을 화면에서 지워버리면 개수가 안 맞는다)
 *        filter     — 남길 권한을 고르는 술어(유효 권한만 보여줄 때 사용)
 */
export function buildPermissionTree(perms, opts = {}) {
    const { skipLegacy = false, filter } = opts;
    const domains = [];
    const domainIdx = new Map();

    for (const p of perms || []) {
        if (skipLegacy && p.domain === LEGACY_DOMAIN) continue;
        if (filter && !filter(p)) continue;

        const dName = p.domain || "기타";
        const tName = p.tab || "기타";

        if (!domainIdx.has(dName)) {
            domainIdx.set(dName, domains.length);
            domains.push({ domain: dName, tabs: [], tabIdx: new Map() });
        }
        const d = domains[domainIdx.get(dName)];

        if (!d.tabIdx.has(tName)) {
            d.tabIdx.set(tName, d.tabs.length);
            d.tabs.push({ tab: tName, perms: [] });
        }
        d.tabs[d.tabIdx.get(tName)].perms.push(p);
    }
    return domains;
}
